import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=a1fa6b38&"
import script from "./ServiceItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports